import { Component, OnInit, Input } from '@angular/core';


import { MatDialog } from '@angular/material/dialog';

import { Constant } from 'src/app/constants/constant';
import { CurrencyConversionService } from 'src/app/services/currency-conversion.service';
import { CommonService } from 'src/app/services/common.service';
import { ProductService } from 'src/app/services/product.service';
import { UserService } from 'src/app/services/user.service';
import { CartService } from 'src/app/services/cart.service';
import { Router } from '@angular/router';
import { Product } from 'src/app/models/app.models';
import { SwiperConfigInterface } from 'src/app/theme/swiper/swiper.module';

@Component({
  selector: 'calsoft-product-carousel',
  templateUrl: './productcarousel.component.html',
  styleUrls: ['./productcarousel.component.scss']
})
export class CalsoftProductcarouselComponent implements OnInit {
  @Input() categoryId: any;
  @Input() header: any;
  @Input() id: any;
  @Input() productImageHeight: any;
  @Input() showCartIcon: any;
  @Input() showCartIncremented: any;
  @Input() data: any;
  @Input() showConfigurableDropdown: any;
  @Input() urlNavigation: any = true;
  @Input() heightMobile: any;
  @Input() widthMobile: any;
  @Input() sortOrder: any;
  @Input() other: any;
  @Input() type: any = "home";
  @Input() height: any;
  @Input() width: any;
  @Input() imageType: any;
  @Input() item: any;
  @Input() slidesPerView: any;
  @Input() hideTitle: any = false;
  @Input() productLayoutType: any;
  categoryProducts: any;
  count: any;
  isEmpty: any;
  pageSize: any;
  public page: any = 0;
  size: number = 10;
  sortParam: any;
  @Input('products') products: Array<Product> = [];
  public config: SwiperConfigInterface = {};
  countryCode: string;
  url: string;

  categoryId5: any = 0;
  categoryId4: any = 0;
  customField27: any;
  customField28: any;
  customField29: any;
  @Input() border: any = 0;

  @Input() gap: any = 0;

  @Input() displayTitle: any = 0;
  mobileShow: number = 2;
  isDealOver: boolean = false;
  date: Date;
  showTimer: boolean;

  // public settings: Settings;
  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private currencyConversionService: CurrencyConversionService,
    private productService: ProductService,
    private userService: UserService,
    private cartServices: CartService,
    private router: Router
  ) {

  }

  productLayoutEnable: any = 0;


  ngOnInit(): void {


    this.mobileShow = 2;
    this.slidesPerView = 4;
    if (this.item) {
      if (this.item.customField30 !== undefined && this.item.customField30 !== null && this.item.customField30 > 0) {
        this.mobileShow = this.item.customField30;
      }

      if (this.item.customField29 !== undefined && this.item.customField29 !== null && this.item.customField29 > 0) {
        this.slidesPerView = this.item.customField29;
      }
    }



    this.url = this.router.url;

    if (this.type != 'product') {
      this.productsByCategory();
    } else {
      this.productsByList();
    }

    if (this.productLayoutType == 17) {

      this.productLayoutEnable = 1

    } else {

      this.productLayoutEnable = 0;

    }


    if (this.item != undefined) {
      if (this.categoryId4 != undefined) {
        this.categoryId4 = this.item.categoryId4;
      }

      if (this.categoryId5 != undefined) {
        this.categoryId5 = this.item.categoryId5;
      }

      if (this.item.customField27 != undefined) {
        document.documentElement.style.setProperty('--custom-width', this.item.customField27);
        this.customField27 = this.item.customField27;
      }


      if (this.item.customField28 != undefined) {
        document.documentElement.style.setProperty('--custom-width-mob', this.item.customField28);
        this.customField28 = this.item.customField28;
      }

      if ((this.item?.customField31 !== undefined 
        
        && this.item?.customField31 !== "")&& this.item?.customField33 !== undefined 
        
        && this.item?.customField33 !== "") {

          let utcDateStr = this.item?.customField31; // e.g., '2025-07-22T18:30:00.000Z'
        let timeStr = this.item?.customField33; // e.g., 'HH:mm'
        
        // Step 1: Convert UTC to IST string
        let istString = new Date(utcDateStr).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
        
        // Step 2: Convert string back to Date object
        let istBaseDate = new Date(istString);
        
        // Step 3: Set time from customField33
        let [hours, minutes] = timeStr.split(':').map(Number);
        istBaseDate.setHours(hours);
        istBaseDate.setMinutes(minutes);
        istBaseDate.setSeconds(0); // Optional: reset seconds
        

        const now = new Date();
        let nowIST = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
        // Step 4: You now have final IST date with time
   
        
        let diffMillis = istBaseDate.getTime() - nowIST.getTime(); // Positive if future, negative if past

        // Convert to useful units
        let diffMinutes = Math.floor(diffMillis / (1000 * 60));
        let diffHours = Math.floor(diffMillis / (1000 * 60 * 60));
        let diffDays = Math.floor(diffMillis / (1000 * 60 * 60 * 24));
         let diffSeconds = Math.floor(diffMillis / 1000);


         if (isNaN(diffSeconds)) {

          diffSeconds=0;
          this.isDealOver = true;

          this.showTimer=false;
         }


         if(diffSeconds){
          this.countdownTarget = istBaseDate;
          this.date=istBaseDate;
          this.showTimer=true;
          this.startCountdown(); // start the timer
         }
         


      }
    } else {
      this.categoryId4 = this.border;
      this.categoryId5 = this.displayTitle;
    }

    let countryCode = this.currencyConversionService.getCountryCode();
    if (countryCode == null) {
      this.countryCode = "INR";
    }
    else {
      this.countryCode = countryCode;
    }

    this.getCustomerCount();

  }

  public productsByCategory() {

    if (this.other == 'category') {
      this.categoryId = this.commonService.getEncryptedId(parseInt(this.id))
      this.productService.productsByCategoryIdx(decodeURIComponent(this.categoryId), this.page, this.size, this.sortOrder).subscribe(
        res => {
          if (res != null) {
            this.categoryProducts = res['content'];
            this.count = res['totalElements'];
            this.isEmpty = res['empty'];
            this.pageSize = res['totalPages']
          } else {
            this.categoryProducts = [];
            this.count = 0;
            this.isEmpty = true;
            this.pageSize = 0
          }
        }

      )
    } else {

      let methodName = "getProductBySearch";
      let search = ''
      if (this.other == 'productScope') {
        methodName = "getProductByCustomProductId";
        search = this.id
      } else {

        let value = 1;
        search = "isInStock:" + '*' + value + '*'
          + "' AND featured:" + '*' + value + '*' + "' "
      }


      this.productService[methodName](search, this.page, this.size, this.sortOrder).subscribe(
        res => {
          this.categoryProducts = res['content'];
          this.count = res['totalElements'];
          this.isEmpty = res['empty'];
          this.pageSize = res['totalPages']
        })
    }
  }


  productsByList() {

    this.categoryProducts = this.products;
  }





  ngAfterViewInit() {
    this.config = {
      observer: true,
      slidesPerView: this.slidesPerView,
      spaceBetween: 10,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        0: {
          slidesPerView: this.mobileShow
        },
        480: {
          slidesPerView: this.mobileShow
        },
        740: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: this.slidesPerView
        },
        1500: {
          slidesPerView: this.slidesPerView
        }
      }
    }
  }


  goToCategory() {
     if (this.other == 'productScope') {
     this.commonService.productSearch(this.id)
     }else{
      this.commonService.goToCategory(1, parseInt(this.id));
     }
  }
  values: any = "*values*";
  getCustomerCount() {

    let authourized = this.userService.getAuthenticatedUser();
    if (authourized) {


      this.cartServices.geWishListProduct();

      this.cartServices.getCustomerCartProductCount().subscribe(
        (response) => {


          this.values = response;

          let value = localStorage.getItem(Constant.CART_COUNT);
          if (value == null) {
            let encryptedValue = btoa(JSON.stringify(response));

            this.userService.storeProductCartCount(encryptedValue);
          }
        },
        (err) => { }
      );
    }
  }


  totalHoursFromAdmin: any; // Set this value from admin input
  private countdownTarget!: Date;
  private timer!: any;

  days = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;


  startCountdown() {
    this.timer = setInterval(() => {
      const now = new Date().getTime();

      
      const distance = this.countdownTarget.getTime() - now;

      if (distance <= 0) {
        this.days = this.hours = this.minutes = this.seconds = 0;
        this.isDealOver = true;
        clearInterval(this.timer);
        this.showTimer=false;

        // 💾 Mark as finished
        localStorage.setItem('countdownFinished', 'true');
        localStorage.removeItem('countdownTarget');
        return;
      }

      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
    }, 1000);
  }


  ngOnDestroy() {
    clearInterval(this.timer);
  }


}
